import React, { Fragment, useRef } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import Controls from './components/Controls';
import { useCarousel } from './hooks/useCarousel';
import './style.scss';
import { ReloadCarouselButton } from '../ReloadCarouselButton';
import { PlaceholderCarrusel } from 'components/PlaceholderCarrusel';
import { getTranslation } from 'utils/getTranslation';
import { getRegion } from 'utils/Region';
import { PLACEHOLDERS } from 'constants.js';
import { isNodeMyContent } from 'utils/Utils';
import { useScrollHorizontalInfiniteCarouse } from './hooks/useScrollHorizontalInfiniteCarouse';

export const ContentsCarouselDreams = ({
  contentsList,
  name,
  getComponent,
  carouselType,
  carouselSubType,
  title,
  node,
  index,
  hasError,
  handleReload,
  setPlanClicked,
  config,
}) => {
  const carouselRef = useRef();
  const translations = useSelector(
    state => JSON.parse(state.metadata.translations).language[getRegion()],
  );
  const asset = useSelector(state => state.asset);
  const {
    canDoCarousel,
    handleNext,
    handlePrev,
    handleDragEnd,
    handleDragOver,
    handleDragStart,
    trackRef,
  } = useCarousel(contentsList);

  const { navData } = useSelector(state => state?.cvNavData);
  const { code: codeMenu } = navData?.selected || {};

  const getKeyPlaceholder = () => {
    const { placeholder } = config?.properties || {};
    const stringKey = `ribbons_placeholder_${placeholder}_label`;
    const key = getTranslation(stringKey, translations);
    return key;
  };

  const getImgPlaceHolder = () => {
    const { placeholder } = config?.properties || {};
    const {
      ribbons_placeholder_MisCanalesFavoritos_background,
      ribbons_placeholder_generic_background,
    } = asset;

    const keyImg =
      placeholder === PLACEHOLDERS?.MISCANALES_FAVORITOS
        ? ribbons_placeholder_MisCanalesFavoritos_background
        : ribbons_placeholder_generic_background;
    return keyImg;
  };

  useScrollHorizontalInfiniteCarouse(carouselRef, trackRef);

  if (contentsList?.length === 0 && !hasError && isNodeMyContent(codeMenu)) {
    return (
      <PlaceholderCarrusel
        title={title}
        description={getKeyPlaceholder()}
        img={getImgPlaceHolder()}
      />
    );
  }

  if (contentsList?.length === 0 && !hasError) return null;

  return (
    <Fragment>
      <Controls
        title={title}
        name={name}
        handleNextSlide={handleNext}
        handlePrevSlide={handlePrev}
        showControls={hasError ? !hasError : canDoCarousel}
      />

      {hasError ? (
        <ReloadCarouselButton handleReload={handleReload} />
      ) : (
        <div className="contents-carousel-dreams" ref={carouselRef}>
          <div
            className="contents-carousel-dreams__track"
            onDragOver={handleDragOver}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            ref={trackRef}
          >
            {_.isArray(contentsList) &&
              contentsList?.map((content, i) => (
                <Fragment key={i}>
                  {getComponent({
                    carouselType,
                    contentInfo: content,
                    node,
                    index,
                    name,
                    rankingPlace: i,
                    carouselSubType,
                    title,
                    setPlanClicked,
                    contentPosition: i,
                  })}
                </Fragment>
              ))}
          </div>
        </div>
      )}
    </Fragment>
  );
};
